/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceGroupQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceGroupQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceGroupQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceGroupQueryOperator>): ResourceGroupQueryOperator {
        let obj = Object.assign(new ResourceGroupQueryOperator(), model);
        ResourceGroupQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceGroupQueryOperator>): ResourceGroupQueryOperator {
        if (!model) return null;
        return ResourceGroupQueryOperator.newInstance(<ResourceGroupQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceGroupQueryOperator) {
        if (!obj) return;

        models.ResourceGroupQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceGroupQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceGroupQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resourcegroups to include
     */
    resource_groups: Array<string>;

}
